import { api } from '@/lib/api';

export type UserProfile = {
  phone: string | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  avatar_url: string | null;
  emergency_contact_name: string | null;
  emergency_contact_relationship: string | null;
  emergency_contact_phone: string | null;
  notify_sms: boolean;
  notify_email: boolean;
  notify_push: boolean;
  marketing_opt_in: boolean;
};

export type UpdateUserProfileInput = {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  emergency_contact_name?: string | null;
  emergency_contact_relationship?: string | null;
  emergency_contact_phone?: string | null;
  notify_sms?: boolean;
  notify_email?: boolean;
  notify_push?: boolean;
  marketing_opt_in?: boolean;
};

export async function fetch_user_profile(): Promise<UserProfile> {
  const res = await api.get<UserProfile>('/user/profile');
  return res.data;
}

export async function update_user_profile(input: UpdateUserProfileInput): Promise<UserProfile> {
  const res = await api.patch<UserProfile>('/user/profile', input);
  return res.data;
}

export async function upload_avatar(file: File): Promise<UserProfile> {
  const form = new FormData();
  form.append('file', file);
  const res = await api.post<UserProfile>('/user/profile/avatar', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
}
